// assets/cart-drawer.js
class CartDrawerComponent extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.isOpen = false;
  }

  open() {
    if (!this.isOpen) {
      this.dialog.showModal();
      this.isOpen = true;
    }
  }

  close() {
    if (this.isOpen) {
      this.dialog.close();
      this.isOpen = false;
    }
  }

async renderContents() {
  try {
    // Pedir el carrito en JSON
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Construir el HTML de los productos con Liquid renderizado desde otro snippet
    // 👉 Aquí lo normal es que tengas una sección como `cart-items` para pedir via AJAX.
    // Si no la tienes, toca armarlo a mano con JS.
    const productsContainer = this.querySelector('.cart-drawer__items');
    productsContainer.innerHTML = '';

    //cart.items.forEach(item => {
    //  productsContainer.innerHTML += `
    //    <div class="cart-item">
    //      <img src="${item.image}" alt="${item.title}" />
    //      <span>${item.title}</span>
    //      <span>${item.quantity} × ${formatMoney(item.price)}</span>
    //    </div>
    //  `;
    //});
//
    //const summaryContainer = this.querySelector('.cart-drawer__summary');
    //summaryContainer.innerHTML = `
    //  <p>Total: ${formatMoney(cart.total_price)}</p>
    //`;

  } catch (err) {
    console.error('Error recargando cart-drawer:', err);
  }
  this.querySelectorAll('.cart-drawer__close-button').forEach(btn => {
  btn.addEventListener('click', () => this.close());
});
}

}

function formatMoney(cents, currency = 'USD') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: currency,
  }).format(cents / 100);
}

customElements.define('cart-drawer-component', CartDrawerComponent);
